
const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = t => t * (2 - t);
const statCounter = document.querySelector('.cs-statcounter');
const csStatInner = document.querySelectorAll('.countup')

if (csStatInner) {
	csStatInner.forEach((item) => {
		let theWidth = item.getBoundingClientRect();
		if (theWidth.width <= 100) {
			item.style.width = theWidth.width + 10 + 'px';
		} else {
			item.style.width = theWidth.width + 'px';
		}

	});
}

const isInViewport = (elem) => {
	if (elem) {
		let bounding = elem.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	} else {
		return false;
	}
};

const animateCountUp = el => {
	let frame = 0;
	const countTo = parseInt(el.innerHTML, 10);
	const counter = setInterval(() => {
		frame++;
		const progress = easeOutQuad(frame / totalFrames);
		const currentCount = Math.round(countTo * progress);
		if (parseInt(el.innerHTML, 10) !== currentCount) {
			el.innerHTML = currentCount;
		}
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
};

const runAnimations = () => {
	const countupEls = document.querySelectorAll('.countup');
	countupEls.forEach(animateCountUp);
};

const doOpacity = () => {
	statCounter.classList.add('active');
}

const stopScreen = () => {
	window.removeEventListener('scroll', checkScreen);
}

const checkScreen = () => {
	if (isInViewport(statCounter) === true) {
		doOpacity();
		runAnimations();
		stopScreen();
	}
}

window.addEventListener('scroll', checkScreen);
